import React, { Component } from 'react';
import './LogInMail.css';
import './Home.css';
import './MancoSSO.css';

class LuxTrustComponenet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: '',
      serverUrl: '',
      imageData: '',
      backgroundImage: '',
      watermarkImage: '',
      imageType: 'jpeg',
      backgroundImageType: 'jpeg',
      watermarkImageType: 'jpeg',
    };
    this.onReceiveMessage = this.onReceiveMessage.bind(this);
  }

  getImage() {
    fetch('config/getImage?name=LuxTrustPageLogo', {
      method: 'POST'
    }).then(response => {
      fetch('config/getImage?name=LuxTrustPageBackGround', {
        method: 'POST'
      }).then(response => {
        fetch('config/getImage?name=LuxTrustPageWatermark', {
          method: 'POST'
        }).then(resp => {
          return resp.json()
        }).then(data => {
          this.setState({
            watermarkImage: data.image,
            watermarkImageType: data.value
          })
        })
        return response.json()
      }).then(data => {
        this.setState({
          backgroundImage: data.image,
          backgroundImageType: data.value
        })
      })
      return response.json()
    }).then(data => {
      this.setState({
        imageData: data.image,
        imageType: data.value
      })
    })
  }

  componentDidMount() {
    fetch('server/url?serverName=AuthorizationServer', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }).then(result => {
      return result.json();
    }).then(data => {
      this.setState({
        serverUrl: data.value
      })
      var parent = this;
      fetch('luxTrust/login', {
        method: 'POST',
        headers: new Headers({
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8, application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      }).then(function (response) {
        response.text().then(function (text) {
          console.log('text', text);
          parent.setState({
            posts: text
          });
        })
      });
      window.addEventListener('message', this.onReceiveMessage);
    })
    this.getImage()
  }



  componentDidUpdate(prevProps, prevState) {
    if (this.state.posts !== prevState.posts) {
      document.SendtoFront.submit();
    }
  }

  onReceiveMessage(e) {
    //console.log("URL FROM ON Receive Message:", this.state.serverUrl);
    console.log("handleReceiveMessage" + e.data + "*http://localhost:8081/MozaikOauth2Server/luxtrust/auth");
    this.setState({ email: e.data });

    fetch(this.state.serverUrl, {
      method: 'POST', redirect: 'follow',
      headers: new Headers({
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      body: e.data,
      credentials: 'same-origin',
    }).then(console.log(e.data))
      .then(response => {
        window.location.href = response.url
      }
      ).catch(err => console.error('Caught error: ', err));
  }

  render() {
    const { posts } = this.state;
    const logoType = this.state.imageType !== "" ? this.state.imageType : "jpeg";
    const backgroundType = this.state.backgroundImageType !== "" ? this.state.backgroundImageType : "jpeg";
    const watermarkType = this.state.watermarkImageType !== "" ? this.state.watermarkImageType : "jpeg";

    const logo64Image = `data:image/${logoType};base64,` + this.state.imageData;
    const background64Image = `data:image/${backgroundType};base64,` + this.state.backgroundImage;
    const base64WatermarkImg = `data:image/${watermarkType};base64,` + this.state.watermarkImage;
    return (
      <div className='twoFactorAuthenticationContainer' style={{ backgroundImage: "url(" + base64WatermarkImg + ")" }}>
        <div >
          <div className='luxTrustContainer'>
            <form target="orely" name="SendtoFront" id="SendtoFront" action="https://orely.test.luxtrust.com/FederatedServiceFrontEnd/saml/auth" method="post">
              <input type="hidden" name="SAMLRequest" value={posts} />
            </form>
            <div className="resp-container">
              <iframe name="orely" frameBorder="0">
              </iframe>
            </div>

          </div>
          <div className='luxtrustLogoContainer'>
            <img src={logo64Image} className='luxTrustauthenticationImage' />
          </div>
        </div>
        <div >
          <img className='luxtrustBackgroudImage' src={background64Image} />
        </div>
        <div>
          <img src={require("./../images/MozaikItau.png")} className='luxTrustMozaikImage' />
          <label className='label-loginManco'>The site is optimized for Microsoft Edge, Google Chrome, Safari and Mozilla Firefox</label>
        </div>
      </div>
    );
  }

}


export const LuxTrust = () => (
  <div>
    <LuxTrustComponenet />
  </div>
);


// WEBPACK FOOTER //
// ./src/main/resources/js/components/LuxTrust.js